<!-- Header -->
<div mat-dialog-title
	style="text-align: center; color: #A20000;"
	role="heading">
	ERRORS EXIST
</div>

<!-- Body -->
<mat-dialog-content>
	{{message}}
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left"></div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button image="Cancel.png"
			label="Close"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>